// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const objectToFormData = (object: any, formData = new FormData()) => {
  const result = formData;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const createFormData = (object: any, subKeyStr: string = '') => {
    for (const i in object) {
      const value = object[i];
      const subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i;

      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        value instanceof File
      ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        result.append(subKeyStrTrans, value);
        continue;
      }

      if (typeof value === 'object') {
        createFormData(value, subKeyStrTrans);
      }
    }
  };

  createFormData(object);

  return result;
};
